import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TemplateService } from "../../../shared/services/template.service";
import { SharedDataService } from "../../../shared/sharedData.service";
import { ModalCloneTemplateComponent } from "../clone/modal-clone-template.component";
import { Router } from "@angular/router";

@Component({
    selector: "tpm-template-list",
    templateUrl: "./template-list.component.html",
    standalone: false
})
export class TimecardTemplateListComponent implements OnInit, OnDestroy {
    constructor(
        private _modalService: BsModalService,
        private _sharedDataService: SharedDataService,
        private router: Router,
        private _eventBus: EventBusService,
        private log: NbcLoggerService
    ) {}

    templates: any;
    queryContainer: any;
    sub = new SubSink();
    buAccess: any;
    defaultOrderBy = "name";
    defaultReverseSort = false;
    searchObj = {
        templateName: "",
    };

    sortColumn($event, column) {
        if (this.queryContainer.query.sortByColumn === column) {
            if (this.queryContainer.query.reverseSort === true) {
                this.queryContainer.query.sortByColumn = this.defaultOrderBy;
                this.queryContainer.query.reverseSort = this.defaultReverseSort;
            } else {
                this.queryContainer.query.reverseSort = true;
            }
        } else {
            this.queryContainer.query.sortByColumn = column;
            this.queryContainer.query.reverseSort = false;
        }

        const data = {
            sortByColumn: this.queryContainer.query.sortByColumn,
            reverseSort: this.queryContainer.query.reverseSort,
        };
        this._eventBus.emit(
            new EmitEvent("sortColumn", "onColumnSortClick", data)
        );
        $event.preventDefault();
    }

    openCloneTemplateModal(template) {
        let bsModalRef: BsModalRef;
        const initialState: any = {
            userBuAccess: this.buAccess,
            template: template,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        bsModalRef = this._modalService.show(
            ModalCloneTemplateComponent,
            modalOptions
        );
        bsModalRef.content.onSync.subscribe((result) => {
            this._eventBus.emit(
                new EmitEvent("openCloneTemplateModal", "searchTemplates", null)
            );
        });
    }

    buildGrid(items) {
        this.templates = items.data;
        this.queryContainer = items.queryContainer;
    }

    subscribeEventHandlers() {
        this.sub.sink = this._sharedDataService
            .getBuAccess()
            .subscribe((access) => (this.buAccess = access));
        this.sub.sink = this._eventBus.on("buildGrid", (result) =>
            this.buildGrid(result)
        );
    }

    ngOnInit() {
        this.subscribeEventHandlers();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
